import {
    ALIGNER_TREATMENT,
    ALIGNER_TREATMENT_EXPECTATION,
    ALIGNER_TREATMENT_MEDICAL_INFORMATION,
    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_CONSULTATION_AND_FINDINGS,
    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_TREATMENT,
    IMPLANT_SURGERY_DOCUMENTATION
} from './anamnesis/const'

export const REDUCER_NAME = 'anamnesis'

export const ANAMNESIS_TITLE = {
    [ALIGNER_TREATMENT]: 'Anamnesis',
    [ALIGNER_TREATMENT_EXPECTATION]: 'Aligner Treatment Expectation',
    [IMPLANT_CONSULTATION_AND_FINDINGS]: 'Implant Consultation and Findings',
    [ALIGNER_TREATMENT_MEDICAL_INFORMATION]: 'Aligner Treatment Medical Condition (typeform)',
    [ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT]: 'Medical Assessment',
    [IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT]: 'Medical Assessment Implant',
    [IMPLANT_TREATMENT]: 'Implant Anamnesis',
    [IMPLANT_SURGERY_DOCUMENTATION]: 'Implant Surgery Documentation',
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/const.js